import type { ReactNode } from 'react'
import { ContentMain, InleagueStatusBanner, useShellTitle } from '@region13/ui'
import { Sidebar } from './Sidebar'
import { FIELDS_NAV } from '../lib/nav'

/** Signed-in frame. Desktop (md+): the shared dark-maroon left Sidebar + content.
 *  Phone (<md): the shared masthead and navigation drawer, which SidebarShell
 *  renders above the content.
 *
 *  No bottom tab bar, unlike coach-spa and referee-spa. Per `.impeccable.md` the
 *  fixed bottom bar is the PHONE tool's idiom, and this is a laptop tool wrapped
 *  around a full-bleed map editor: nobody draws field geometry on a phone. Two
 *  destinations plus the editor also do not earn a tab bar. Below md the drawer
 *  and breadcrumbs carry navigation.
 *
 *  The content column is max-w-5xl, not the max-w-2xl this shell started with: the
 *  subfield table is eight columns wide and ran out of room on a desktop window,
 *  truncating the InLeague picker and pushing row actions past the edge. */
export function AppShell({
  email,
  onSignOut,
  children,
}: {
  email: string
  onSignOut: () => void
  children: ReactNode
}) {
  // A child page (a venue, a layout) sets its own title once its data loads.
  useShellTitle(FIELDS_NAV)
  return (
    <div className="flex min-h-screen flex-col bg-canvas md:flex-row">
      <Sidebar email={email} onSignOut={onSignOut} />
      <div className="flex min-w-0 flex-1 flex-col">
        <ContentMain className="mx-auto w-full max-w-5xl px-4 py-5">
          <InleagueStatusBanner className="mb-4" />
          {children}
        </ContentMain>
      </div>
    </div>
  )
}
